var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _c(
        "div",
        { staticClass: "cf-action-container" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary md-just-icon md-round",
              attrs: { title: "Add team custom fields" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleAddCustomField()
                },
              },
            },
            [_c("md-icon", [_vm._v("add")])],
            1
          ),
        ],
        1
      ),
      _c(
        "md-table",
        { staticClass: "custom-paginated-table" },
        [
          _c(
            "md-table-row",
            [
              _c("md-table-head", [_vm._v("Group")]),
              _c("md-table-head", [_vm._v("Label")]),
              _c("md-table-head", [_vm._v("Type")]),
              _c("md-table-head", { staticClass: "actions" }, [
                _vm._v("Actions"),
              ]),
            ],
            1
          ),
          _vm._l(_vm.tandemGroups, function (customField, index) {
            return _c(
              "md-table-row",
              { key: customField.group + "-" + index + "-tandem" },
              [
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(customField.label) +
                      "\n            "
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        customField.fields[0].label +
                          " + " +
                          customField.fields[1].label
                      ) +
                      "\n            "
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$_camelCaseToSentenceCase(
                          customField.fields[0].type
                        ) +
                          " + " +
                          _vm.$_camelCaseToSentenceCase(
                            customField.fields[1].type
                          )
                      ) +
                      "\n            "
                  ),
                ]),
                _c(
                  "md-table-cell",
                  { staticClass: "action-buttons" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-warning md-just-icon md-round",
                        attrs: { title: "edit custom field" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleEditCustomField(customField)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("edit")])],
                      1
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger md-just-icon md-round",
                        attrs: { title: "delete custom field" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemoveCustomField(
                              customField.group
                            )
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("delete")])],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._l(_vm.standaloneFieldsGroup, function (fld, index) {
            return _c(
              "md-table-row",
              { key: fld.name + "-" + index + "-standaloneFields" },
              [
                _c("md-table-cell", [
                  _vm._v("\n                 \n            "),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " + _vm._s(fld.label) + "\n            "
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$_camelCaseToSentenceCase(fld.type)) +
                      "\n            "
                  ),
                ]),
                _c(
                  "md-table-cell",
                  { staticClass: "action-buttons" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-warning md-just-icon md-round",
                        attrs: { title: "edit custom field" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleEditCustomField(
                              fld,
                              _vm.standaloneFieldsGroupName
                            )
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("edit")])],
                      1
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger md-just-icon md-round",
                        attrs: { title: "delete custom field" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemoveCustomField(
                              _vm.standaloneFieldsGroupName,
                              fld.name
                            )
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("delete")])],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }